import { useAuth } from "@/context/AuthContext";
import MessageThread from "@/components/MessageThread";

export default function ClientMessages() {
  const { user } = useAuth();
  return (
    <div>
      <h1 className="font-serif font-bold text-3xl text-white mb-1">Messages</h1>
      <p className="text-slate-400 mb-5">A secure line to your accounting team.</p>
      <MessageThread clientId={user.client_id} />
    </div>
  );
}
